import PropTypes from 'prop-types';

import HeaderContainerGrid from '@/components/headerContainer/Grid';
import { HeaderActions, HeaderSeparator, ReportDatePicker, RunButton } from '@/components/reports/header'

export default function ReportsAllocationHeader({ onChangeDates, dates, sync, isLoading }) {
  return <>
    <HeaderContainerGrid title='URL Anomalies Report'>
      <HeaderActions>
        <ReportDatePicker dates={dates} onChange={onChangeDates} />
        <HeaderSeparator />
        <RunButton onClick={sync} isLoading={isLoading} disabled={isLoading} />
      </HeaderActions>
    </HeaderContainerGrid>
  </>
}

ReportsAllocationHeader.propTypes = {
  onChangeDates: PropTypes.func,
  dates: PropTypes.object,
  sync: PropTypes.func,
  isLoading: PropTypes.bool,
};
